const cards = [
  {
    tag: '新剧上线',
    title: '古装探案新标杆《长安诡事录》',
    desc: '盛唐背景下的连环奇案，烧脑程度拉满',
    img: 'https://readdy.ai/api/search-image?query=Tang%20dynasty%20Chinese%20detective%20drama%20scene%2C%20ancient%20palace%20corridor%20with%20lanterns%2C%20mysterious%20figure%20in%20traditional%20costume%2C%20atmospheric%20fog%20and%20warm%20candlelight%2C%20cinematic%20composition%2C%20historical%20mystery%20aesthetic&width=600&height=400&seq=cards-01-detective&orientation=landscape',
  },
  {
    tag: '高分推荐',
    title: '豆瓣 9.5 神作《人间世》纪录片',
    desc: '真实镜头记录生命力量，每一帧都触动人心',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20film%20style%20scene%2C%20warm%20natural%20light%20through%20window%2C%20everyday%20life%20moment%20captured%20with%20emotional%20depth%2C%20cinematic%20documentary%20aesthetic%2C%20soft%20focus%20background%2C%20intimate%20and%20authentic%20atmosphere&width=600&height=400&seq=cards-02-documentary&orientation=landscape',
  },
  {
    tag: '限时热播',
    title: '好莱坞大片《星际征途》全国首播',
    desc: '顶级特效打造科幻史诗，年度必看视觉盛宴',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20battle%20scene%2C%20massive%20spaceships%20over%20alien%20planet%2C%20dramatic%20explosions%20and%20laser%20beams%2C%20cinematic%20wide%20shot%2C%20deep%20space%20background%20with%20stars%2C%20blockbuster%20movie%20aesthetic&width=600&height=400&seq=cards-03-scifi-epic&orientation=landscape',
  },
  {
    tag: '热播综艺',
    title: '《披星戴月》第二季强势回归',
    desc: '全明星阵容再出发，笑点泪点齐飞不容错过',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20TV%20show%20stage%20with%20performers%2C%20bright%20stage%20lighting%20and%20audience%20silhouettes%2C%20energetic%20entertainment%20atmosphere%2C%20variety%20show%20production%20aesthetic%2C%20vibrant%20and%20dynamic%20composition&width=600&height=400&seq=cards-04-variety&orientation=landscape',
  },
  {
    tag: '国漫推荐',
    title: '水墨风动画《山海异闻》惊艳上线',
    desc: '传统水墨与现代动画完美融合，国风之美尽显',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20animation%20scene%2C%20mythical%20mountain%20landscape%20with%20flowing%20waterfall%2C%20traditional%20oriental%20art%20aesthetic%2C%20soft%20ink%20textures%20and%20misty%20atmosphere%2C%20elegant%20classical%20composition&width=600&height=400&seq=cards-05-ink-anime&orientation=landscape',
  },
  {
    tag: '经典重温',
    title: '周星驰喜剧全集高清修复版',
    desc: '那些年笑到肚子疼的经典桥段，现在画质更清晰',
    img: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20comedy%20movie%20scene%20style%2C%20vibrant%20colorful%20street%20market%20setting%2C%20warm%20nostalgic%20film%20grain%20texture%2C%20retro%201990s%20cinema%20aesthetic%2C%20lively%20and%20joyful%20atmosphere&width=600&height=400&seq=cards-06-comedy&orientation=landscape',
  },
  {
    tag: '悬疑专区',
    title: '烧脑神剧《暗夜追踪》全集上线',
    desc: '每集一个反转，国产悬疑剧天花板级别作品',
    img: 'https://readdy.ai/api/search-image?query=Noir%20thriller%20scene%2C%20rainy%20city%20alley%20at%20night%20with%20street%20lamp%20glow%2C%20mysterious%20shadow%20figure%2C%20suspenseful%20cinematic%20lighting%2C%20dark%20and%20moody%20atmosphere%2C%20crime%20drama%20aesthetic&width=600&height=400&seq=cards-07-thriller&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-1">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-500">编辑精选好片，每天都有新发现</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {cards.slice(0, 3).map((card, idx) => (
            <div
              key={idx}
              className={`group relative rounded-xl overflow-hidden border border-background-200/60 bg-background-100 hover:border-primary-200 transition-all cursor-pointer ${
                idx === 0 ? 'sm:col-span-2 sm:row-span-2' : ''
              }`}
            >
              <div className={`${idx === 0 ? 'aspect-[16/9] sm:aspect-auto sm:h-full' : 'aspect-[16/9]'} w-full overflow-hidden`}>
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={card.title}
                  loading="lazy"
                />
              </div>
              <div className={`absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent pointer-events-none ${idx === 0 ? '' : ''}`}></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="inline-block px-2 py-0.5 rounded bg-accent-500 text-background-50 text-[10px] font-semibold mb-2">
                  {card.tag}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-background-50 mb-1">{card.title}</h3>
                <p className="text-xs text-background-50/80">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
          {cards.slice(3).map((card, idx) => (
            <div
              key={idx + 3}
              className="group relative rounded-xl overflow-hidden border border-background-200/60 bg-background-100 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[16/10] w-full overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={card.title}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded bg-accent-500 text-background-50 text-[10px] font-semibold">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{card.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}